import { render, staticRenderFns } from "./AddMatchForOlympic.vue?vue&type=template&id=54127edc&scoped=true"
import script from "./AddMatchForOlympic.vue?vue&type=script&lang=js"
export * from "./AddMatchForOlympic.vue?vue&type=script&lang=js"
import style0 from "./AddMatchForOlympic.vue?vue&type=style&index=0&id=54127edc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54127edc",
  null
  
)

export default component.exports